const PropTypes = require('prop-types');
// @vendor
const React = require('react');

// @utils
const { formatText } = require('core/i18n').i18n;

// @constants
const {
    BROKER_ADVANCED_SEARCH_DEFAULT_ALL_VALUE,
    TYPE_ETFS
 } = require('constants/index');

// @components
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { InputSafe } = require('commonsComponents/inputSafe');


class ETFsFilters extends React.Component {
    constructor(props) {
        super(props);

        this.handleIssuerChange = this.handleIssuerChange.bind(this);
        this.handleCategoryChange = this.handleCategoryChange.bind(this);
        this.handleNameInput = this.handleNameInput.bind(this);
        this.handleMarketChange = this.handleMarketChange.bind(this);
        this.handleLeverageChange = this.handleLeverageChange.bind(this);
        this.handleComplexityChange = this.handleComplexityChange.bind(this);
    }

    adaptSelectOptions(opts, femaleText) {
        const options = opts.toJS();
        const allText = femaleText ? 'broker-allOptionsF': 'broker-allOptionsM';

        return [
            {value: BROKER_ADVANCED_SEARCH_DEFAULT_ALL_VALUE, label: formatText(allText)},
            ...options.map(item => {
                return {
                    value: item.idClassification,
                    label: item.description,
                    item
                };
            })
        ];
    }

    handleCategoryChange(category) {
        this.props.onHandleFieldChange('category', category.value);
    }

    handleComplexityChange(complexity) {
        this.props.onHandleFieldChange('complexity', complexity.value);
    }

    handleIssuerChange(issuer) {
        this.props.onHandleFieldChange('issuer', issuer.value);
    }

    handleLeverageChange(leverage) {
        this.props.onHandleFieldChange('leverage', leverage.value);
    }

    handleMarketChange(market) {
        this.props.onHandleFieldChange('market', market.value);
    }


    handleNameInput(ev) {
        if (ev.target.value !== ' ') {
            this.props.onHandleFieldChange('term', ev.target.value);
        }
    }

    render() {
        const { searchState } = this.props;
        const etfsFilters = searchState.getIn(['filters', TYPE_ETFS]);
        const etfsSelectedValues = searchState.getIn(['selectedValues', TYPE_ETFS]);

        const issuers = this.adaptSelectOptions(etfsFilters.get('issuers'));
        const categories = this.adaptSelectOptions(etfsFilters.get('categories'), true);
        const leverages = this.adaptSelectOptions(etfsFilters.get('leverages'));
        const complexities = this.adaptSelectOptions(etfsFilters.get('complexities'), true);
        const markets = this.adaptSelectOptions(etfsFilters.get('markets'));

        const activeIssuer = etfsSelectedValues.get('issuer');
        const activeCategory = etfsSelectedValues.get('category');
        const activeMarket = etfsSelectedValues.get('market');
        const activeLeverage = etfsSelectedValues.get('leverage');
        const activeComplexity = etfsSelectedValues.get('complexity');

        const nameInputValue = etfsSelectedValues.get('term');
        const nameInputLabel = formatText('broker-advancedSearchNameIsinLabel');

        const errorMessage = formatText('broker-advancedSearchNameNotEmptyIfNoFilterSelect');

        return (
            <div>
                <div className="broker-advanced-search-explore__full-row">
                    <div className="broker-advanced-search-explore__one-third-box">
                        <label className="broker-advanced-search-explore__label">
                            {nameInputLabel}
                        </label>
                        <InputSafe
                            id="inpBrokerAdvancedSearchTerm"
                            name="advanced-search-name"
                            value={nameInputValue}
                            onChange={this.handleNameInput}
                            type="text"
                            errorState={!this.props.validation.etfsNameValid}
                            errorMessage={errorMessage}
                        />
                    </div>
                </div>
                <div className="broker-advanced-search-explore__full-row">
                    <div className="broker-advanced-search-explore__one-third-box">
                        <OKSelect
                            id="selBrokerAdvancedSearchPromoter"
                            label="broker-advancedSearchPromoterLabel"
                            name="advanced-search-promoter"
                            options={issuers}
                            value={activeIssuer}
                            clearable={false}
                            searchable={false}
                            onChange={this.handleIssuerChange}
                        />
                    </div>
                    <div className="broker-advanced-search-explore__one-third-box">
                        <OKSelect
                            id="selBrokerAdvancedSearchCategory"
                            label="broker-advancedSearchCategoryLabel"
                            name="advanced-search-category"
                            options={categories}
                            value={activeCategory}
                            clearable={false}
                            searchable={false}
                            onChange={this.handleCategoryChange}
                        />
                    </div>
                    <div className="broker-advanced-search-explore__one-third-box">
                        <OKSelect
                            id="selBrokerAdvancedSearchMarket"
                            label="broker-advancedSearchMarketLabel"
                            name="advanced-search-market"
                            options={markets}
                            value={activeMarket}
                            clearable={false}
                            searchable={false}
                            onChange={this.handleMarketChange}
                        />
                    </div>
                </div>
                <div className="broker-advanced-search-explore__full-row">
                    <div className="broker-advanced-search-explore__one-third-box">
                        <OKSelect
                            id="selBrokerAdvancedSearchLeverage"
                            label="broker-advancedSearchLeverageLabel"
                            name="advanced-search-leverage"
                            options={leverages}
                            value={activeLeverage}
                            clearable={false}
                            searchable={false}
                            onChange={this.handleLeverageChange}
                        />
                    </div>
                    <div className="broker-advanced-search-explore__one-third-box">
                        <OKSelect
                            id="selBrokerAdvancedSearchComplexity"
                            label="broker-advancedSearchComplexityLabel"
                            name="advanced-search-complexity"
                            options={complexities}
                            value={activeComplexity}
                            clearable={false}
                            searchable={false}
                            onChange={this.handleComplexityChange}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

ETFsFilters.propTypes = {
    showAdditionalFilters: PropTypes.bool,
    searchState: PropTypes.object.isRequired,
    onHandleFieldChange: PropTypes.func.isRequired,
    onHandleToggleAdditionalFilters: PropTypes.func,
    validation: PropTypes.object.isRequired
};

module.exports = ETFsFilters;


/** TODO once currencies in API
 *
 * constant
 *
BROKER_ADVANCED_SEARCH_CURRENCIES_SPLIT_STRING
 *
 * paste in render
 *
const currencies = this.adaptCurrenciesOptions(searchState.getIn(['filters', TYPE_ETFS, 'currencies']));
const activeCurrency = searchState.getIn(['selectedValues', TYPE_ETFS, 'currency']);

<div className="broker-advanced-search-explore__one-third-box">
    <OKSelect
        id="selBrokerAdvancedSearchCurrency"
        label="broker-advancedSearchCurrencyLabel"
        name="advanced-search-currency"
        options={currencies}
        value={activeCurrency}
        clearable={false}
        searchable={false}
        onChange={this.handleCurrencyChange}
    />
</div>

 *
 * class methods
 *
this.handleCurrencyChange = this.handleCurrencyChange.bind(this);

handleCurrencyChange(category) {
    this.props.onHandleFieldChange('currency', category.value);
}

adaptCurrenciesOptions(options) {
    options = options.toJS();
    return [
        {value: BROKER_ADVANCED_SEARCH_DEFAULT_ALL_VALUE, label: formatText('broker-allOptionsF')},
        ...options.map(item => {
            return {value: item, label: item.split(BROKER_ADVANCED_SEARCH_CURRENCIES_SPLIT_STRING)[1]};
        })
    ];
}

*/